// Define default configurations
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var defaultConfigs = {
    apiHost: "https://app.launchdarkly.com",
    requestTimeoutMs: 5000,
    fetchProvider: global.fetch
};
// Holder for the active configurations
var activeConfigs = _extends({}, defaultConfigs);
/**
 * Sets or updates configuration settings by merging new configuration objects
 * with the existing active configurations. This function ensures that any new settings
 * provided will override the corresponding old settings in `activeConfigs`.
 *
 * @param {Object} newConfigs - The new configuration settings as an object. Each key-value
 *                              pair in the object will update or add to the existing configurations.
 * @throws {Error} Throws an error if `newConfigs` is not an object, ensuring type safety.
 *
 * @example
 * // Example of setting new configurations
 * setConfigs({ apiHost: 'https://newapi.example.com', timeout: 5000 });
 *
 * // This will throw an error because the input is not an object
 * try {
 *   setConfigs('invalid');
 * } catch (error) {
 *   console.error(error);
 * }
 */ var setConfigs = function(newConfigs) {
    if (typeof newConfigs !== "object") {
        throw new Error("Configurations must be an object.");
    }
    // Merge the new configurations with the active configurations
    activeConfigs = _extends({}, activeConfigs, newConfigs);
};
/**
 * Retrieves the current active configuration settings. This function returns a reference
 * to the active configuration object, allowing callers to access the latest settings directly.
 *
 * @returns {Object} The current active configuration settings.
 *
 * @example
 * // Example of retrieving the active configurations
 * const currentConfigs = getConfigs();
 * console.log(currentConfigs); // Outputs the current active configurations
 */ var getConfigs = function() {
    return activeConfigs;
};
export { setConfigs, getConfigs };
